declare namespace $ {

	type $mol_paragraph__title_bog_invest_calc_1 = $mol_type_enforce<
		ReturnType< $bog_invest_calc['import_label'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_button_open_native__files_bog_invest_calc_2 = $mol_type_enforce<
		ReturnType< $bog_invest_calc['xlsx_files'] >
		,
		ReturnType< $mol_button_open_native['files'] >
	>
	type $mol_button_open_native__accept_bog_invest_calc_3 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_open_native['accept'] >
	>
	type $mol_button_open_native__multiple_bog_invest_calc_4 = $mol_type_enforce<
		boolean
		,
		ReturnType< $mol_button_open_native['multiple'] >
	>
	type $mol_button_open__sub_bog_invest_calc_5 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_open['sub'] >
	>
	type $mol_paragraph__title_bog_invest_calc_6 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_view__sub_bog_invest_calc_7 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_paragraph__title_bog_invest_calc_8 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_switch__value_bog_invest_calc_9 = $mol_type_enforce<
		ReturnType< $bog_invest_calc['quartile'] >
		,
		ReturnType< $mol_switch['value'] >
	>
	type $mol_switch__options_bog_invest_calc_10 = $mol_type_enforce<
		ReturnType< $bog_invest_calc['quartile_options'] >
		,
		ReturnType< $mol_switch['options'] >
	>
	type $mol_view__sub_bog_invest_calc_11 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_paragraph__title_bog_invest_calc_12 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_number__value_bog_invest_calc_13 = $mol_type_enforce<
		ReturnType< $bog_invest_calc['capital'] >
		,
		ReturnType< $mol_number['value'] >
	>
	type $mol_view__sub_bog_invest_calc_14 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_paragraph__title_bog_invest_calc_15 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_number__value_bog_invest_calc_16 = $mol_type_enforce<
		ReturnType< $bog_invest_calc['min_order'] >
		,
		ReturnType< $mol_number['value'] >
	>
	type $mol_view__sub_bog_invest_calc_17 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_invest_calc_18 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_paragraph__title_bog_invest_calc_19 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_textarea__hint_bog_invest_calc_20 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_textarea['hint'] >
	>
	type $mol_textarea__value_bog_invest_calc_21 = $mol_type_enforce<
		ReturnType< $bog_invest_calc['portfolio_text'] >
		,
		ReturnType< $mol_textarea['value'] >
	>
	type $mol_view__sub_bog_invest_calc_22 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_invest_calc_23 = $mol_type_enforce<
		ReturnType< $bog_invest_calc['result_content'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_invest_calc_24 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_paragraph__title_bog_invest_calc_25 = $mol_type_enforce<
		ReturnType< $bog_invest_calc['order_bond'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_paragraph__title_bog_invest_calc_26 = $mol_type_enforce<
		ReturnType< $bog_invest_calc['order_move'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_paragraph__title_bog_invest_calc_27 = $mol_type_enforce<
		ReturnType< $bog_invest_calc['order_rub'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_paragraph__title_bog_invest_calc_28 = $mol_type_enforce<
		ReturnType< $bog_invest_calc['result_empty_text'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_list__rows_bog_invest_calc_29 = $mol_type_enforce<
		ReturnType< $bog_invest_calc['warning_rows'] >
		,
		ReturnType< $mol_list['rows'] >
	>
	type $mol_paragraph__title_bog_invest_calc_30 = $mol_type_enforce<
		ReturnType< $bog_invest_calc['summary_text'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_list__rows_bog_invest_calc_31 = $mol_type_enforce<
		ReturnType< $bog_invest_calc['order_rows'] >
		,
		ReturnType< $mol_list['rows'] >
	>
	type $mol_button_major__title_bog_invest_calc_32 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_major['title'] >
	>
	type $mol_button_major__click_bog_invest_calc_33 = $mol_type_enforce<
		ReturnType< $bog_invest_calc['save'] >
		,
		ReturnType< $mol_button_major['click'] >
	>
	type $mol_paragraph__title_bog_invest_calc_34 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_paragraph__title_bog_invest_calc_35 = $mol_type_enforce<
		ReturnType< $bog_invest_calc['warning_text'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_view__attr_bog_invest_calc_36 = $mol_type_enforce<
		({ 
			'bog_invest_action': ReturnType< $bog_invest_calc['order_kind'] >,
		}) 
		,
		ReturnType< $mol_view['attr'] >
	>
	type $mol_view__sub_bog_invest_calc_37 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	export class $bog_invest_calc extends $mol_page {
		import_label( ): string
		Import_label( ): $mol_paragraph
		xlsx_files( next?: readonly(File)[] ): readonly(File)[]
		Import_native( ): $mol_button_open_native
		Import( ): $mol_button_open
		Local_hint( ): $mol_paragraph
		Import_card( ): $mol_view
		Quartile_label( ): $mol_paragraph
		quartile( next?: string ): string
		quartile_options( ): Record<string, any>
		Quartile( ): $mol_switch
		Quartile_field( ): $mol_view
		Capital_label( ): $mol_paragraph
		capital( next?: number ): number
		Capital( ): $mol_number
		Capital_field( ): $mol_view
		Min_order_label( ): $mol_paragraph
		min_order( next?: number ): number
		Min_order( ): $mol_number
		Min_order_field( ): $mol_view
		Params_card( ): $mol_view
		Portfolio_label( ): $mol_paragraph
		portfolio_text( next?: string ): string
		Portfolio( ): $mol_textarea
		Portfolio_card( ): $mol_view
		result_content( ): readonly(any)[]
		Result_card( ): $mol_view
		Content( ): $mol_view
		result_empty_text( ): string
		warning_rows( ): readonly(any)[]
		summary_text( ): string
		order_rows( ): readonly(any)[]
		save( next?: any ): any
		warning_text( id: any): string
		order_kind( id: any): string
		order_bond( id: any): string
		Order_bond( id: any): $mol_paragraph
		order_move( id: any): string
		Order_move( id: any): $mol_paragraph
		order_rub( id: any): string
		Order_rub( id: any): $mol_paragraph
		title( ): string
		Head( ): any
		body( ): readonly(any)[]
		Result_empty( ): $mol_paragraph
		Warnings( ): $mol_list
		Summary( ): $mol_paragraph
		Orders( ): $mol_list
		Save( ): $mol_button_major
		Saved_note( ): $mol_paragraph
		Warning_row( id: any): $mol_paragraph
		Order_row( id: any): $mol_view
	}
	
}

//# sourceMappingURL=calc.view.tree.d.ts.map